export default "/static/kx2_tiny.png";